import { render } from "./view-more.vue?vue&type=template&id=9f2cdcfa"
import script from "./view-more.vue?vue&type=script&lang=js"
export * from "./view-more.vue?vue&type=script&lang=js"

import "./view-more.vue?vue&type=style&index=0&id=9f2cdcfa&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__